import React from "react";
import BlogSlider from "./BlogTopList";
import BlogSidebar from "../BlogSidebar/BlogSidebar";
import { Link } from "react-router-dom";

const T = "#00c896";
const N = "#0f2040";

const ArrowIcon = () => (
  <>
    {[0, 1].map(i => (
      <svg key={i} width="20" height="19" viewBox="0 0 20 19" fill="none">
        <rect x="3.783" y="13.463" width="14.31" height="1.817" transform="rotate(-40.2798 3.783 13.463)" fill="white"/>
        <rect x="5.807" y="4.605" width="1.817" height="1.817" transform="rotate(-40.2798 5.807 4.605)" fill="white"/>
        <rect x="8.367" y="4.816" width="1.817" height="1.817" transform="rotate(-40.2798 8.367 4.816)" fill="white"/>
        <rect x="10.926" y="5.028" width="1.817" height="1.817" transform="rotate(-40.2798 10.926 5.028)" fill="white"/>
        <rect x="13.277" y="7.8" width="1.817" height="1.817" transform="rotate(-40.2798 13.277 7.8)" fill="white"/>
        <rect x="13.066" y="10.361" width="1.817" height="1.817" transform="rotate(-40.2798 13.066 10.361)" fill="white"/>
        <rect x="12.855" y="12.922" width="1.817" height="1.817" transform="rotate(-40.2798 12.855 12.922)" fill="white"/>
      </svg>
    ))}
  </>
);

// ── SVG Blog Cover Illustrations ──────────────────────────────────────────────
const CoverOnboarding = () => (
  <svg viewBox="0 0 480 220" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%", display: "block" }}>
    <rect width="480" height="220" fill={N} rx="10"/>
    {/* Flow steps */}
    {[
      {x:48,  label:"Upload ID",  icon:"📄", done:true},
      {x:168, label:"Face Scan",  icon:"👤", done:true},
      {x:288, label:"AML Check",  icon:"🔍", done:true},
      {x:408, label:"Verified",   icon:"✓",  done:false},
    ].map((s,i) => (
      <g key={i}>
        {i < 3 && <line x1={s.x+32} y1={90} x2={s.x+120} y2={90} stroke="rgba(0,200,150,0.3)" strokeWidth="2" strokeDasharray="4 2"/>}
        <circle cx={s.x} cy={90} r={32} fill={s.done?"rgba(0,200,150,0.15)":"rgba(0,200,150,0.25)"} stroke={T} strokeWidth={s.done?1:2}/>
        <text x={s.x} y={95} fontSize="16" textAnchor="middle">{s.icon}</text>
        <text x={s.x} y={136} fontSize="9" fill="rgba(255,255,255,0.55)" textAnchor="middle" fontFamily="system-ui">{s.label}</text>
      </g>
    ))}
    <text x="240" y="180" fontSize="11" fontWeight="700" fill={T} textAnchor="middle" fontFamily="system-ui">90-second end-to-end onboarding</text>
    <text x="240" y="196" fontSize="9" fill="rgba(255,255,255,0.3)" textAnchor="middle" fontFamily="system-ui">down from 3 business days</text>
  </svg>
);

const CoverDocOCR = () => (
  <svg viewBox="0 0 480 220" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%", display: "block" }}>
    <rect width="480" height="220" fill="#0a1628" rx="10"/>
    {/* KTP card */}
    <rect x="30" y="30" width="200" height="130" rx="10" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.12)" strokeWidth="1.5"/>
    <rect x="30" y="30" width="200" height="36" rx="10" fill="rgba(0,200,150,0.2)"/>
    <rect x="30" y="56" width="200" height="10" fill="rgba(0,200,150,0.1)"/>
    <text x="130" y="50" fontSize="8" fontWeight="700" fill={T} textAnchor="middle" fontFamily="system-ui">KARTU TANDA PENDUDUK</text>
    <rect x="44" y="72" width="44" height="56" rx="4" fill="rgba(255,255,255,0.08)"/>
    <circle cx="66" cy="88" r="10" fill="rgba(255,255,255,0.15)"/>
    <ellipse cx="66" cy="112" rx="14" ry="10" fill="rgba(255,255,255,0.15)"/>
    {[["NIK","3201xxxxxxxxxxxx",80],["Nama","BUDI SANTOSO",96],["TTL","Jakarta, 01-01-1990",112],["Alamat","Jl. Sudirman No.1",128]].map(([l,v,y],i) => (
      <g key={i}>
        <text x="98" y={y as number} fontSize="6" fill="rgba(255,255,255,0.35)" fontFamily="system-ui">{l}</text>
        <text x="98" y={(y as number)+9} fontSize="7" fontWeight="600" fill="rgba(255,255,255,0.75)" fontFamily="system-ui">{v}</text>
      </g>
    ))}
    {/* Arrow */}
    <path d="M240 95 L270 95" stroke={T} strokeWidth="2" strokeDasharray="3 2" markerEnd="url(#arr)"/>
    <defs><marker id="arr" markerWidth="6" markerHeight="6" refX="3" refY="3" orient="auto"><path d="M0 0 L6 3 L0 6 Z" fill={T}/></marker></defs>
    {/* Extracted panel */}
    <rect x="270" y="30" width="180" height="130" rx="10" fill="rgba(0,200,150,0.08)" stroke="rgba(0,200,150,0.25)" strokeWidth="1.5"/>
    <text x="360" y="50" fontSize="9" fontWeight="700" fill={T} textAnchor="middle" fontFamily="system-ui">EXTRACTED DATA</text>
    {[["NIK","320123..."],["Name","Budi Santoso"],["DOB","01-01-1990"],["Addr","Jl. Sudirman"]].map(([k,v],i) => (
      <g key={i}>
        <text x="284" y={70+i*26} fontSize="7" fill="rgba(255,255,255,0.35)" fontFamily="system-ui">{k}</text>
        <text x="284" y={82+i*26} fontSize="8" fontWeight="600" fill="rgba(255,255,255,0.8)" fontFamily="system-ui">{v}</text>
      </g>
    ))}
    <rect x="284" y="140" width="132" height="14" rx="7" fill={T}/>
    <text x="350" y="151" fontSize="8" fontWeight="700" fill={N} textAnchor="middle" fontFamily="system-ui">✓ VALID DOCUMENT</text>
    <text x="240" y="188" fontSize="10" fontWeight="700" fill={T} textAnchor="middle" fontFamily="system-ui">98.5% OCR accuracy · 15+ document types</text>
  </svg>
);

const CoverRisk = () => (
  <svg viewBox="0 0 480 220" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: "100%", height: "100%", display: "block" }}>
    <rect width="480" height="220" fill={N} rx="10"/>
    {/* Gauge */}
    <path d="M120 160 A80 80 0 0 1 280 160" stroke="#374151" strokeWidth="16" fill="none" strokeLinecap="round"/>
    <path d="M120 160 A80 80 0 0 1 280 160" stroke="url(#rg2)" strokeWidth="16" fill="none" strokeLinecap="round" strokeDasharray="251 0"/>
    <defs><linearGradient id="rg2" x1="120" y1="0" x2="280" y2="0"><stop offset="0%" stopColor="#ef4444"/><stop offset="50%" stopColor="#f59e0b"/><stop offset="100%" stopColor={T}/></linearGradient></defs>
    <line x1="200" y1="160" x2="265" y2="105" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
    <circle cx="200" cy="160" r="6" fill="white"/><circle cx="200" cy="160" r="3" fill={N}/>
    <text x="200" y="140" fontSize="28" fontWeight="900" fill={T} textAnchor="middle" fontFamily="system-ui">87</text>
    <text x="200" y="155" fontSize="9" fill="rgba(255,255,255,0.4)" textAnchor="middle" fontFamily="system-ui">Risk Score</text>
    <text x="108" y="178" fontSize="8" fill="#ef4444" fontFamily="system-ui">High</text>
    <text x="192" y="184" fontSize="8" fill="#f59e0b" textAnchor="middle" fontFamily="system-ui">Med</text>
    <text x="284" y="178" fontSize="8" fill={T} textAnchor="end" fontFamily="system-ui">Low</text>
    {/* Factor bars */}
    <rect x="320" y="40" width="140" height="140" rx="10" fill="rgba(255,255,255,0.04)" stroke="rgba(255,255,255,0.08)" strokeWidth="1"/>
    <text x="390" y="62" fontSize="9" fontWeight="700" fill="rgba(255,255,255,0.6)" textAnchor="middle" fontFamily="system-ui">Risk Factors</text>
    {[{l:"Device Trust",s:92,c:T},{l:"Geo Velocity",s:45,c:"#f59e0b"},{l:"Liveness",s:98,c:T},{l:"Doc Validity",s:89,c:T}].map((f,i) => (
      <g key={i}>
        <text x="332" y={82+i*28} fontSize="8" fill="rgba(255,255,255,0.45)" fontFamily="system-ui">{f.l}</text>
        <rect x="332" y={86+i*28} width="108" height="6" rx="3" fill="rgba(255,255,255,0.08)"/>
        <rect x="332" y={86+i*28} width={108*f.s/100} height="6" rx="3" fill={f.c}/>
        <text x="448" y={94+i*28} fontSize="7" fontWeight="700" fill={f.c} textAnchor="end" fontFamily="system-ui">{f.s}</text>
      </g>
    ))}
    <text x="240" y="200" fontSize="10" fontWeight="700" fill={T} textAnchor="middle" fontFamily="system-ui">ML-powered · real-time scoring · 0.3% false positive</text>
  </svg>
);

const articles = [
  {
    tag: "#eKYC",
    tagColor: T,
    title: "How TrustEngine cut fintech onboarding from 3 days to 90 seconds",
    excerpt: "A deep-dive into the architecture behind our eKYC pipeline — passive liveness, document OCR, and AML in a single API call that resolves in under 2 seconds.",
    author: "Rian Hidayat",
    date: "Mar 28, 2025",
    readTime: "6 min read",
    cover: <CoverOnboarding />,
    withImage: true,
  },
  {
    tag: "#Compliance",
    tagColor: "#6366f1",
    title: "The complete guide to OJK eKYC compliance for Indonesian fintechs",
    excerpt: "Everything you need to know about POJK No. 12/2024 — mandatory liveness detection, document validation, AML screening requirements, and audit trail obligations.",
    author: "Tim TrustEngine",
    date: "Mar 15, 2025",
    readTime: "9 min read",
    cover: null,
    withImage: false,
  },
  {
    tag: "#Document OCR",
    tagColor: "#f97316",
    title: "KTP, Passport, SIM, NPWP: how our OCR engine handles 15+ Indonesian document types",
    excerpt: "Our document extraction engine uses a multi-model ensemble trained on 10M+ real Indonesian documents — here's how it handles low light, blur, and bent cards.",
    author: "Tim TrustEngine",
    date: "Mar 5, 2025",
    readTime: "7 min read",
    cover: <CoverDocOCR />,
    withImage: true,
  },
  {
    tag: "#Risk & Fraud",
    tagColor: "#ef4444",
    title: "Building a fraud-proof onboarding flow: lessons from 50M+ verifications",
    excerpt: "After processing over 50 million identity checks, we've identified the top 8 attack vectors in digital onboarding — and how each one is countered in the TrustEngine stack.",
    author: "Tim TrustEngine",
    date: "Feb 20, 2025",
    readTime: "11 min read",
    cover: null,
    withImage: false,
  },
  {
    tag: "#Risk Scoring",
    tagColor: T,
    title: "How our ML risk engine scores 10,000 identity checks per second",
    excerpt: "Inside the TrustEngine real-time risk scoring pipeline — device fingerprinting, geo-velocity checks, behavioral signals, and ensemble model inference at scale.",
    author: "Tim TrustEngine",
    date: "Feb 8, 2025",
    readTime: "8 min read",
    cover: <CoverRisk />,
    withImage: true,
  },
];

const BlogList: React.FC = () => {
  return (
    <div>
      <BlogSlider />
      <section className="blog_details_section pt-120">
        <div className="container">
          <div className="row mt-none-50 g-0 align-items-start">
            <div className="col-lg-8 mt-50">
              <div className="blog_details_content">
                {articles.map((art, idx) => (
                  <div key={idx} className={`blog_details_item xb-border${art.withImage ? " img-hove-effect ul_li" : ""}`}>
                    {art.withImage && art.cover && (
                      <div className="xb-item--img xb-img" style={{ overflow: "hidden", borderRadius: 10 }}>
                        <Link to="/blog-details">{art.cover}</Link>
                      </div>
                    )}
                    <div className={art.withImage ? "xb-item--holder" : "xb-item--inner"}>
                      {/* Tag */}
                      <Link to="/blog-details" className="xb-item--tag"
                        style={{ color: art.tagColor, borderColor: art.tagColor + "40" }}>
                        {art.tag}
                      </Link>
                      {/* Title */}
                      <h3 className="xb-item--title border-effect-2">
                        <Link to="/blog-details">{art.title}</Link>
                      </h3>
                      {/* Meta */}
                      <div style={{ display: "flex", gap: 16, fontSize: 12, color: "rgba(15,32,64,0.45)", marginBottom: 12, flexWrap: "wrap" }}>
                        <span>✍ {art.author}</span>
                        <span>📅 {art.date}</span>
                        <span>⏱ {art.readTime}</span>
                      </div>
                      {/* Excerpt */}
                      <span className="xb-item--content">{art.excerpt}</span>
                      {/* CTA */}
                      <div className="xb-item--button mt-40">
                        <Link className="thm-btn agency-btn" to="/blog-details">
                          <span className="text">Read more</span>
                          <span className="arrow"><span className="arrow-icon"><ArrowIcon /></span></span>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}

                {/* Pagination */}
                <ul className="blog-pagination ul_li">
                  <li><Link className="xb-border" to="#"><i className="fas fa-chevron-double-left"></i></Link></li>
                  <li className="active"><Link className="xb-border" to="#">1</Link></li>
                  <li><Link className="xb-border" to="#">2</Link></li>
                  <li><Link className="xb-border" to="#">3</Link></li>
                  <li><Link className="xb-border" to="#"><i className="fas fa-chevron-double-right"></i></Link></li>
                </ul>
              </div>
            </div>
            <BlogSidebar />
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogList;
